import React, { Component } from "react";

import { Translate } from "react-redux-i18n";

import "../../../styles/components/map/filter/Filter.scss";
import cross from "../../../styles/images/cross.svg";
import StationFilter from "./StationFilter";
import ConnectorType from "./ConnectorType";
import ParkingType from "./ParkingType";
import VehicleType from "./VehicleType";
import AvailableFilter from "./AvailableFilter";

class Filter extends Component {
  render() {
    if (this.props.show)
      return (
        <div id="filter">
          <button type="button" className="clear" onClick={this.props.onClose}>
            <img src={cross} alt="" />
          </button>
          <p className="title">
            <Translate value="mapFilter_filter" />
          </p>
          <AvailableFilter
            tariffType={this.props.filters.tariffType}
            handleSelectTariffType={this.props.handleSelectTariffType}
            availableStations={this.props.filters.availableStations}
          />
          <hr />
          <StationFilter
            sliders={this.props.filters.sliders}
            stations={this.props.filters.stations}
            onSliderChange={this.props.handleSliderChange}
            onRatingChange={this.props.handleRatingChange}
            onSelectStation={this.props.handleSelectStation}
          />
          <hr />
          <ConnectorType
            plugs={this.props.filters.plugs}
            onPlugClick={this.props.handlePlugClick}
          />
          <hr />
          <ParkingType
            parkingTypes={this.props.filters.parkingTypes}
            onParkingTypeClick={this.props.handleParkingTypeClick}
          />
          <hr />
          <VehicleType
            vehicleTypes={this.props.filters.vehicleTypes}
            onVehicleTypeClick={this.props.handleVehicleTypeClick}
          />
          <div className="apply-btn-container">
            <button type="button" onClick={this.props.onApplyFilter}>
              <Translate value="mapFilter_apply" />
            </button>
          </div>
        </div>
      );
    else return null;
  }
}

export default Filter;
